import { createSlice } from "@reduxjs/toolkit";
import { NOTIFICATION_MAX_VISIBLE } from "../constants/notificationConstants";

function nextId() {
  return `${Date.now()}_${Math.random().toString(36).slice(2, 11)}`;
}

const notificationSlice = createSlice({
  name: "notification",
  initialState: {
    /** @type {{ id: string, type: string, item: any, createdAt: number }[]} */
    items: [],
  },
  reducers: {
    enqueueNotification: (state, action) => {
      const id = nextId();
      state.items.push({
        id,
        type: action.payload?.type ?? "default",
        item: action.payload?.item ?? action.payload,
        createdAt: Date.now(),
      });
      while (state.items.length > NOTIFICATION_MAX_VISIBLE) {
        state.items.shift();
      }
    },
    removeNotification: (state, action) => {
      const id = action.payload;
      state.items = state.items.filter((n) => n.id !== id);
    },
    clearNotifications: (state) => {
      state.items = [];
    },
  },
});

export const {
  enqueueNotification,
  removeNotification,
  clearNotifications,
} = notificationSlice.actions;

/** @deprecated Use enqueueNotification — same payload shape `{ type, item }`. */
export const pushNotification = enqueueNotification;

/** @deprecated Use clearNotifications */
export const clearNotification = clearNotifications;

export default notificationSlice.reducer;
